export enum ColorTypes {
    Custom = 'custom',
    Dot = 'dot'
}